import React from 'react';
import Section from './Section';
import { Link } from 'react-router-dom';

const Noticias = () => {
  const carouselRef = React.useRef(null);

  const news = [
    {
      id: 30,
      slug: 'aeago-novamed-dia-do-engenheiro-agronomo-2026',
      title: 'Dia do Engenheiro Agrônomo: AEAGO e Novamed anunciam parceria em saúde para associados',
      date: '12 de outubro de 2026',
      summary: 'AEAGO e Novamed Planos de Saúde se unem para oferecer um benefício especial de saúde aos associados, em celebração ao Dia do Engenheiro Agrônomo.',
      image: '/imagem/noticias/noticia-novamed.jpeg',
      content: 'Mais cuidado com a saúde e tranquilidade para o dia a dia dos associados da AEAGO.'
    },
    {
      id: 29,
      slug: 'aeago-lanca-revisao-tabela-honorarios-2026',
      title: 'AEAGO lança revisão da Tabela de Honorários Profissionais',
      date: '24 de setembro de 2026',
      summary: 'Revisão contempla aviação agrícola, drones e agricultura de precisão, hidroponia e fertirrigação, e traz destaque para propriedade intelectual e inovação.',
      image: '/imagem/noticias/Nova_tabela.png',
      content: 'Confira a nova Tabela de Honorários Profissionais da Engenharia Agronômica.'
    },
    {
      id: 28,
      slug: 'revista-inova-agro-lancamento-outubro-2026',
      title: 'A Revista Inova Agro está chegando',
      date: '14 de setembro de 2026',
      summary: 'Primeira edição da Revista Inova Agro, com lançamento previsto para outubro, terá como dossiê temático o I Congresso de Agronomia na AgroCapital e conta com o patrocínio do Confea.',
      image: '/imagem/noticias/revista_inova.jpeg',
      content: 'Lançamento previsto para outubro de 2026.'
    },
    {
      id: 27,
      slug: 'aeago-selecionada-edital-patrocinio-confea-revista-inova-agro',
      title: 'AEAGO é selecionada no Edital de Patrocínio do Confea com a Revista Inova Agro',
      date: '12 de setembro de 2026',
      summary: 'AEAGO é selecionada no Edital de Patrocínio nº 3/2026 do Confea com a Revista Inova Agro, cuja primeira edição será dedicada ao I Congresso de Agronomia na AgroCapital.',
      image: '/imagem/noticias/edital_patrocinio.jpeg',
      content: 'Publicação técnico-científica terá sua primeira edição dedicada ao Inova Agro - I Congresso de Agronomia na AgroCapital.'
    },
    {
      id: 26,
      slug: 'aeago-define-posicao-institucional-cba-2027',
      title: 'AEAGO define posição institucional para o CBA 2027',
      date: '28 de agosto de 2026',
      summary: 'Diretoria aprova três propostas institucionais para as tratativas do Termo de Cooperação com a CONFAEAB, visando à realização do XXXV Congresso Brasileiro de Agronomia.',
      image: '/imagem/noticias/reuniao-diretoria-CBA.jpeg',
      content: 'Confira as três propostas aprovadas pela Diretoria da AEAGO para o CBA 2027.'
    },
    {
      id: 25,
      slug: 'queimadas-em-goias-alerta-aeago',
      title: 'Queimadas em Goiás: um alerta que vai além dos prejuízos imediatos',
      date: '23 de agosto de 2026',
      summary: 'Presidente da AEAGO e do Fórum Brasil Central, Fernando Barnabé, alerta para os R$ 710 milhões em prejuízos e até 20 anos de recuperação das áreas atingidas pelo fogo em Goiás.',
      image: '/imagem/noticias/queimadas.jpeg',
      content: 'Fernando Barnabé destaca a importância da prevenção e da atuação conjunta para reduzir os danos provocados pelo fogo no campo goiano.'
    },
    {
      id: 24,
      slug: 'do-campo-ao-mercado-patentes-inovacao-transferencia-tecnologia',
      title: 'Do Campo ao Mercado: patentes, inovação e transferência de tecnologia na Agronomia',
      date: '15 de agosto de 2026',
      summary: 'Novo curso mostra como o Engenheiro Agrônomo pode proteger, licenciar e transformar inovações do campo em negócio e impacto para o Agro.',
      image: '/imagem/curso/do-campo-ao-mercado.jpeg',
      content: 'Inscreva-se e saiba como proteger e transferir tecnologia na Agronomia.'
    },
    {
      id: 23,
      slug: 'dra-mariangela-hungria-abertura-cbcs',
      title: 'Dra. Mariangela Hungria confirmada para abertura do XL Congresso Brasileiro de Ciência do Solo',
      date: '1 de agosto de 2026',
      summary: 'Pesquisadora da Embrapa Soja e vencedora do World Food Prize 2025 fará a palestra magna sobre o papel da ciência do solo na construção de uma agricultura regenerativa.',
      image: '/imagem/noticias/CBCS-MARIANGELA.jpeg',
      content: 'Confira os detalhes da palestra magna que abrirá o XL Congresso Brasileiro de Ciência do Solo.'
    },
    {
      id: 20,
      slug: 'aeago-fortalece-protagonismo-na-cbh-paranaiba',
      title: 'AEAGO fortalece protagonismo na gestão das águas e passa a integrar instância estratégica do CBH Paranaíba',
      date: '24 de julho de 2026',
      summary: 'Associação dos Engenheiros Agrônomos de Goiás passa a integrar o Grupo de Acompanhamento do Contrato de Gestão (GACG) do CBH Paranaíba, reforçando seu protagonismo na governança dos recursos hídricos e no desenvolvimento sustentável.',
      image: '/imagem/noticias/aeago-cbh-paranaiba01.jpeg',
      content: 'A AEAGO ampliou sua atuação ao tomar posse como membro do CBH Paranaíba, integrando também o Grupo de Acompanhamento do Contrato de Gestão (GACG).'
    },
    {
      id: 21,
      slug: 'publicacao-oficial-dos-anais-do-inova-agro',
      title: 'Publicação Oficial dos Anais do Inova Agro',
      date: '19 de julho de 2026',
      summary: 'Foram publicados oficialmente os Anais do I Congresso de Agronomia na Agrocapital, reunindo os trabalhos científicos apresentados durante um dos principais eventos do agronegócio brasileiro.',
      image: '/imagem/noticias/publicacao-anais-inova-agro02.jpeg',
      content: 'A publicação marca um importante legado para a produção científica do agronegócio brasileiro, com mais de 2 mil participantes e 62 trabalhos científicos.'
    },
    {
      id: 22,
      slug: 'thais-eloila-contemplada-sorteio-soea-2026',
      title: 'Thais Heloila é contemplada no sorteio da vaga para a SOEA 2026',
      date: '10 de julho de 2026',
      summary: 'Associada Thais Heloila foi contemplada no sorteio da vaga para participação na 81ª Semana Oficial da Engenharia e da Agronomia (SOEA 2026), após atender a todos os requisitos do regulamento.',
      image: '/imagem/noticias/thais-eloila-sorteio-soea-2026.jpeg',
      content: 'A AEAGO anuncia com grande satisfação que a associada Thais Heloila foi a contemplada no sorteio da vaga para participação na SOEA 2026.'
    },
    {
      id: -1,
      slug: 'aeago-interior',
      title: 'AEAGO pelo interior: presença que se faz na estrada!',
      date: '7 de julho de 2026',
      summary: 'O presidente da AEAGO, Eng. Agr. Fernando Barnabé, percorreu nas últimas semanas mais de 2.000 km pelas estradas de Goiás, visitando municípios, ouvindo profissionais e fortalecendo a presença da Associação junto a quem faz a Agronomia acontecer todos os dias.',
      image: '/imagem/noticias/aeago-interior.jpeg',
      content: 'Mais de 2 mil quilômetros de estrada. Uma AEAGO cada vez mais próxima do interior.'
    },
    {
      id: 0,
      slug: 'colheita-milho',
      title: 'AEAGO participa da Abertura Estadual da Colheita de Milho – 2ª Safra 2026 e reforça compromisso com o agronegócio goiano',
      date: '26 de junho de 2026',
      summary: 'Presidente Fernando Barnabé representou a entidade ao lado da Aprosoja Goiás, fortalecendo a integração institucional e o apoio ao desenvolvimento sustentável, à inovação e à valorização da Engenharia Agronômica.',
      image: '/imagem/noticias/colheita-milho01.jpeg',
      content: 'AEAGO ao lado de quem faz o agro acontecer.'
    },
    {
      id: 1,
      slug: 'agro-uruacu',
      title: 'Presidente da AEAGO fortalece diálogo com lideranças do agronegócio em Uruaçu',
      date: '23 de junho de 2026',
      summary: 'No dia 23 de junho, o presidente da Associação dos Engenheiros Agrônomos de Goiás (AEAGO), Eng. Agr. Fernando Barnabé, esteve em Uruaçu em uma importante agenda de aproximação com os profissionais e lideranças do agronegócio do Norte Goiano.',
      image: '/imagem/noticias/uruacu01.jpeg',
      content: 'Diálogo e fortalecimento do agronegócio em Uruaçu.'
    },
    {
      id: 2,
      slug: 'conexao-safra',
      title: 'Inova Agro estreia como primeiro congresso acadêmico dentro da AgroCapital',
      date: '14 de maio de 2026',
      summary: 'Evento será realizado entre os dias 2 e 4 de junho, em Goiânia, reunindo pesquisadores, profissionais, estudantes, produtores e lideranças do setor dentro da maior feira do agronegócio do Centro-Oeste',
      image: '/imagem/noticias/conexao-safra.jpeg',
      content: 'Feira AgroCapital.'
    },
    {
      id: 3,
      slug: 'aeago-no-portal-agro-2',
      title: 'AEAGO NO PORTAL AGRO 2',
      date: '7 de abril de 2026',
      summary: 'Entrevista com o Presidente Fernando Barnabé no Portal Agro 2 .',
      image: '/imagem/noticias/portal-agro-2.png',
      content: 'Plantando ideias. Colhendo soluções.'
    },
    {
      id: 4,
      slug: 'resultado-do-sorteio-aeago-2026',
      title: 'RESULTADO DO SORTEIO AEAGO 2026',
      date: '31 de março de 2026',
      summary: 'Parabéns aos contemplados no sorteio AEAGO 2026.',
      image: '/imagem/noticias/resultado-sorteio-aeago-2026.png',
      content: 'Acesse para ver os contemplados.'
    },
    {
      id: 5,
      slug: 'novo-telefone-contato',
      title: 'Novo número para contato',
      date: '30 de março de 2026',
      summary: 'Estamos de número novo para contato, atualize em sua agenda.',
      image: '/imagem/noticias/novo-numero.jpeg',
      content: 'Atenção número novo!'
    },
    {
      id: 6,
      slug: 'o-agro-do-brasil-central-na-tv',
      title: 'O Agro do Brasil Central na TV',
      date: '30 de março de 2026',
      summary: 'Participação do presidente Fernando Barnabé no programa Agronegócio da TV Serra Dourada | SBT, representando o Fórum Brasil Central de Agronomia.',
      image: '/imagem/noticias/o-agro-do-brasil-central-na-tv.png',
      content: 'O agronegócio ganha ainda mais força e representatividade na TV Serra Dourada | SBT.'
    },
  ];


  const scrollCarousel = (direction) => {
    if (!carouselRef.current) return;

    const container = carouselRef.current;
    const firstCard = container.querySelector('[data-news-card]');
    const cardWidth = firstCard ? firstCard.clientWidth : 320;
    const gap = 24;
    const offset = cardWidth + gap;

    container.scrollBy({
      left: direction === 'next' ? offset : -offset,
      behavior: 'smooth',
    });
  };

  return (
    <Section id="noticias" bgClass="bg-gray-50" title="Notícias">
        <p className="max-w-3xl mx-auto text-center mb-4 text-gray-700">
          Fique por dentro das últimas notícias e atualizações da AEAGO.
        </p>
        <div className="flex flex-wrap justify-center gap-3 mb-6">
          <a
            href="/documentos/clipping_AEAGO.pdf"
            download
            className="bg-navy text-white py-2 px-6 rounded-full border border-gold hover:bg-secondary text-sm font-semibold"
          >
            Baixe o Clipping de Imprensa AEAGO
          </a>
          <a
            href="/documentos/clipping02_AEAGO.pdf"
            download
            className="bg-navy text-white py-2 px-6 rounded-full border border-gold hover:bg-secondary text-sm font-semibold"
          >
            Baixe o Clipping de Imprensa Maio a Julho/2026
          </a>
          <a
            href="/documentos/noticias_aeago.pdf"
            download
            className="bg-navy text-white py-2 px-6 rounded-full border border-gold hover:bg-secondary text-sm font-semibold"
          >
            Baixe o Compilado de Notícias AEAGO
          </a>
        </div>
        <div className="max-w-6xl mx-auto">
          <div className="flex justify-end gap-2 mb-4">
            <button
              type="button"
              onClick={() => scrollCarousel('prev')}
              className="px-3 py-2 rounded-full border border-gray-300 bg-white hover:bg-gray-100"
              aria-label="Notícia anterior"
            >
              ←
            </button>
            <button
              type="button"
              onClick={() => scrollCarousel('next')}
              className="px-3 py-2 rounded-full border border-gray-300 bg-white hover:bg-gray-100"
              aria-label="Próxima notícia"
            >
              →
            </button>
          </div>
          <div
            ref={carouselRef}
            className="flex gap-6 overflow-x-auto snap-x snap-mandatory pb-2 scroll-smooth"
          >
          {news.map((item) => (
            <div
              key={item.id}
              data-news-card
              className="snap-start min-w-[85%] sm:min-w-[48%] lg:min-w-[31%] bg-white shadow-lg rounded-lg overflow-hidden flex flex-col"
            >
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-64 object-cover object-[center_top] flex-shrink-0"
              />
              <div className="p-4 flex flex-col flex-1">
                <h3 className="text-base sm:text-lg font-semibold mb-2 leading-tight">{item.title}</h3>
                <p className="text-xs sm:text-sm text-gray-500 mb-2">{item.date}</p>
                <p className="text-sm text-gray-700 mb-4 flex-1">{item.summary}</p>
                {item.pdf && (
                  <a
                    href={item.pdf}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block text-navy hover:text-secondary font-semibold mb-2 text-sm"
                  >
                    📄 Abrir Documento (PDF)
                  </a>
                )}
                <Link
                  to={`/noticias/${item.slug}`}
                  className="bg-navy text-white py-2 px-4 rounded-full border border-gold hover:bg-secondary text-sm text-center"
                >
                  Saiba mais
                </Link>
              </div>
            </div>
          ))}
          </div>
        </div>

  </Section>
  );
};

export default Noticias;
